import React, {Component} from 'react';
import {inject} from 'mobx-react';

//helpers
import {richTextHasValue} from 'utils/string-utils';

//components
import Icon from 'components/Icon';
import {TextMobile as Text} from 'components/Text';

//styled-components
import {IconAndTextWrapper, ItemButton, ToolbarItem} from './styles';

@inject('store')
class ToolbarItemComponent extends Component {
  showContent = () => {
    const {showHint, iconId} = this.props;

    if (typeof showHint === 'function') {
      showHint(iconId);
    }
  };

  render() {
    const {active, label = null, themeIcon, type, isEnabled, isWarning} = this.props;

    return (
      <ToolbarItem active={active} data-cy={type}>
        <ItemButton
          hasContent={isEnabled}
          onClick={isEnabled ? this.showContent : null}
          disabled={!isEnabled}
          active={active}
          className={active ? 'active' : ''}
          isWarning={isWarning}
        >
          <IconAndTextWrapper>
            <div className={'inline-hint-svg'} dangerouslySetInnerHTML={{__html: themeIcon}} />
            {label && (
              <Text tag={'label'} size={'small'}>
                {label}
              </Text>
            )}
          </IconAndTextWrapper>
        </ItemButton>
      </ToolbarItem>
    );
  }
}

export default ToolbarItemComponent;
